import { Type } from 'class-transformer';
import { FileInfoDisplayResultDto } from '../../../../../_models/file-info-display-result-dto';
import { KeyValueResultDto } from '../../../../../_models/key-value-result-dto';
import { UpdatedResultDto } from '../../common/updated-result-dto';
import { ARAdjustmentItemResultDto } from './ar-adjustment-item-result-dto';

export class ARAdjustmentResultDto {
    arAdjustmentId: number;
    referenceType: string;
    referenceId: number;
    referenceNumber: string;
    cashOrAccrual: string;
    debitOrCredit: string;

    @Type(() => Date)
    docDate: Date;

    @Type(() => Date)
    postDate: Date;

    customerName: string;
    customerId: number;
    customerCode: string;
    description: string;
    amount: number;
    openBalance: number;

    subLedger: string;
    allowReverse: boolean;
    allowWriteOff: boolean;
    allowDelete: boolean;

    /*
        If this is true, we allow to edit these fields from the UI:
        - DebitOrCredit
        - Description
        - DocDate
        - PostDate
        - SubLedger
        - Attachments on the header level.

        We also allow to edit all line item's info:
        - GLAccount
        - OffsetGLAccount
        - AccountLabel
        - Sub-category
        - Amount
        - Fund
        - Item's description
        - Dimensions
        They can add/delete line items.

        The line item's open balance is a readonly field.

        If this is true, AllowBasicEdit will always be true.

        If this is false, we look at the value of AllowBasicEdit to see what information is allowed to be updated.
    */
    allowEdit: boolean;

    /*
        If AllowEdit is true, AllowBasicEdit doesn't matter.
        If AllowEdit is false and AllowBasicEdit is true, users can only change line items' subcategory.
        If AllowEdit is false and AllowBasicEdit is false, users can't make any change.
    */
    allowBasicEdit: boolean;

    reversed: boolean;

    @Type(() => Date)
    reversedDate: Date;

    reversalAdjustmentId: number;
    writeOffInfoDisplayText: string;
    hasCreditApplications: boolean;
    deleted: boolean;

    @Type(() => Date)
    deletedDate: Date;

    @Type(() => ARAdjustmentItemResultDto)
    items: ARAdjustmentItemResultDto[];

    @Type(() => UpdatedResultDto)
    lastUpdated: UpdatedResultDto;

    @Type(() => FileInfoDisplayResultDto)
    attachments: FileInfoDisplayResultDto[];

    @Type(() => KeyValueResultDto)
    requiredDimensions: KeyValueResultDto[];

    entityUsesSubcategory: boolean;

    message: string;
    messageDetails: string;
    allowCreditApplications: boolean;
}
